import { useFetch } from './useFetch';
import { formsApi } from '../api/formsApi';

/**
 * Renvoie la définition (id + champs_json) du formulaire actif correspondant au type demandé.
 * Exemple : const { definition, loading } = useFormDefinition('devis');
 */
export function useFormDefinition(type) {
  const { data: definitions, loading, error } = useFetch(() => formsApi.list(), []);

  const definition = definitions?.find((d) => d.type === type) || null;

  return { definition, loading, error };
}
